import React from "react";

import { StyledSVG } from "../StyledIcon";

export const HideIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M16.1493 10.0189L15.5553 9.56095L16.1493 10.0189ZM16.1493 7.98114L15.5553 8.43905L16.1493 7.98114ZM15.5553 9.56095C14.9513 10.3445 14.0012 11.4408 12.8372 12.3351C11.6658 13.2351 10.3503 13.875 9 13.875V15.375C10.818 15.375 12.4524 14.5223 13.7511 13.5245C15.0573 12.521 16.0977 11.3142 16.7433 10.4768L15.5553 9.56095ZM9 13.875C7.64966 13.875 6.33422 13.2351 5.16275 12.3351C3.99881 11.4408 3.04871 10.3445 2.44467 9.56095L1.25669 10.4768C1.90228 11.3142 2.94266 12.521 4.24888 13.5245C5.54758 14.5223 7.18199 15.375 9 15.375V13.875ZM2.44467 8.43905C3.04871 7.65549 3.99881 6.55917 5.16275 5.66493C6.33422 4.76489 7.64966 4.125 9 4.125V2.625C7.18199 2.625 5.54758 3.47767 4.24888 4.47545C2.94266 5.47902 1.90228 6.68578 1.25669 7.52324L2.44467 8.43905ZM9 4.125C10.3503 4.125 11.6658 4.76489 12.8372 5.66493C14.0012 6.55917 14.9513 7.65549 15.5553 8.43905L16.7433 7.52324C16.0977 6.68578 15.0573 5.47902 13.7511 4.47545C12.4524 3.47767 10.818 2.625 9 2.625V4.125ZM2.44467 9.56095C2.18461 9.2236 2.18461 8.7764 2.44467 8.43905L1.25669 7.52324C0.5806 8.40026 0.580602 9.59974 1.25669 10.4768L2.44467 9.56095ZM16.7433 10.4768C17.4194 9.59974 17.4194 8.40026 16.7433 7.52324L15.5553 8.43905C15.8154 8.7764 15.8154 9.2236 15.5553 9.56095L16.7433 10.4768Z"
        fill={iconColor}
      />
      <path
        d="M10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25C8.40326 11.25 7.83097 11.0129 7.40901 10.591C6.98705 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.98705 7.83097 7.40901 7.40901C7.83097 6.98705 8.40326 6.75 9 6.75C9.59674 6.75 10.169 6.98705 10.591 7.40901C11.0129 7.83097 11.25 8.40326 11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591L10.591 10.591Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 14.25L3.75 3.75"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
